export default __webpack_public_path__ + "static/media/logo-dark.4c330cb6.svg";